(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SymptomDeleteController',SymptomDeleteController);

    SymptomDeleteController.$inject = ['$uibModalInstance', 'entity', 'Symptom'];

    function SymptomDeleteController($uibModalInstance, entity, Symptom) {
        var vm = this;

        vm.symptom = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Symptom.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
